(() => {
  if (window.faunivaReviewsV3) return;
  window.faunivaReviewsV3 = true;

  const writeSelector = '[data-testid="write-review-button"],.jdgm-write-rev-link,button[aria-label*="write" i],a[aria-label*="write" i]';
  const findNativeButton = root => [...root.querySelectorAll(writeSelector)].find(button => {
    if (button.closest('.jdgm-legacy-widget-content') || button.disabled) return false;
    const text = (button.textContent || '').replace(/\s+/g, ' ').trim();
    return button.matches('[data-testid="write-review-button"],.jdgm-write-rev-link') || /write.+review/i.test(text);
  });

  const decorateModal = root => {
    const modal = document.querySelector('.jdgm-write-review-modal,.jdgm-review-widget-modal');
    if (!modal) return;
    modal.dataset.faunivaStyled = 'true';
    const image = modal.querySelector('.jdgm-write-review-modal__product-image img');
    if (image) { image.removeAttribute('src'); image.removeAttribute('srcset'); }
  };

  const openReview = root => {
    const controls = root.querySelectorAll('[data-fauniva-write-review]');
    const status = root.querySelector('[data-fauniva-review-status]');
    const engine = root.querySelector('[data-fauniva-review-engine]');
    const start = performance.now();
    let timer;
    let observer;
    const finish = () => {
      clearInterval(timer);
      observer?.disconnect();
      controls.forEach(button => button.removeAttribute('aria-busy'));
    };
    const attempt = () => {
      const nativeButton = findNativeButton(root);
      if (nativeButton) {
        finish();
        if (status) status.textContent = '';
        nativeButton.click();
        requestAnimationFrame(() => decorateModal(root));
        setTimeout(() => decorateModal(root), 250);
        setTimeout(() => decorateModal(root), 1000);
        return true;
      }
      if (performance.now() - start > 10000) {
        finish();
        engine?.classList.add('is-visible');
        if (status) status.textContent = 'The review form is ready below.';
      }
      return false;
    };
    controls.forEach(button => button.setAttribute('aria-busy', 'true'));
    if (status) status.textContent = 'Opening review form…';
    if (attempt()) return;
    observer = new MutationObserver(attempt);
    observer.observe(engine || root, { childList: true, subtree: true });
    timer = setInterval(attempt, 300);
  };

  const revealForLocation = () => {
    const root = document.querySelector('[data-fauniva-product-reviews]');
    if (!root) return;
    if (location.hash === '#judgeme_review_form') openReview(root);
    if (['#shopify-product-reviews', '#judgeme_product_reviews'].includes(location.hash)) {
      root.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  };

  document.addEventListener('click', event => {
    const carouselControl = event.target.closest('[data-fauniva-review-prev],[data-fauniva-review-next]');
    if (carouselControl) {
      const root = carouselControl.closest('[data-fauniva-home-reviews]');
      const track = root?.querySelector('[data-fauniva-review-track]');
      if (!track) return;
      const direction = carouselControl.hasAttribute('data-fauniva-review-prev') ? -1 : 1;
      const card = track.querySelector('.fauniva-home-review__card');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || track.clientWidth) + gap), behavior: 'smooth' });
      return;
    }
    const trigger = event.target.closest('[data-fauniva-write-review]');
    if (!trigger) return;
    openReview(trigger.closest('[data-fauniva-product-reviews]'));
  });
  decorateModal();
  setTimeout(decorateModal, 500);
  setTimeout(decorateModal, 2000);
  revealForLocation();
  window.addEventListener('hashchange', revealForLocation);
  document.addEventListener('shopify:section:load', revealForLocation);
})();
